/**
 * The signed-in user, read from the local session.
 *
 * `supabase.auth.getUser()` asks the auth server every time it is called, and
 * the app called it ~100 times: a dashboard load made a dozen round trips to
 * /auth/v1/user before its first query, one after the other. The session in
 * local storage already holds the user and is refreshed by the client when it
 * expires, and every query is still checked by row level security on the
 * server, so the browser does not need the network to know who is signed in.
 *
 * Same shape as getUser(): `const { data: { user } } = await getAuthUser();`
 * Edge functions keep verifying tokens with getUser(token) server-side.
 */
import { supabase } from "@/integrations/supabase/client";

export async function getAuthUser() {
  const { data, error } = await supabase.auth.getSession();
  return { data: { user: data.session?.user ?? null }, error };
}
